import { sendToApi } from 'api/client'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'
import { UseMutationOptions, useMutation } from 'react-query'

type Props = {
  videoId: string
}

type Data = {
  batch_id: string
}

type Variables = {
  media_file_key: string
}

type Options = Omit<UseMutationOptions<Data, unknown, Variables>, 'mutationKey' | 'mutationFn'>

const replaceVideoContent = async (workspaceId: number, videoId: string, mediaFileKey: string) => {
  const res = await sendToApi<Data>(`/w/${workspaceId}/videos/${videoId}/replace_content`, {
    method: 'POST',
    body: { media_file_key: mediaFileKey },
  })

  if (res.type !== SUCCESS_RESPONSE_TYPE) {
    throw new Error(res.data)
  }

  return res.data
}

export const useReplaceVideoContent = ({ videoId }: Props, options?: Options) => {
  const workspaceId = useCurrentWorkspaceId()
  return useMutation<Data, Error, Variables>(
    (params) => replaceVideoContent(workspaceId, videoId, params.media_file_key),
    options,
  )
}
